import React, { FC, PropsWithChildren, ReactNode, memo } from 'react';

import Typography from '@mui/material/Typography';

import useStyles from './styles.module';

interface Props extends PropsWithChildren {
  title?: string | ReactNode;
  className?: string;
  classNameChildren?: string;
}

const Box: FC<Props> = ({ className, children, title, classNameChildren }) => {
  const { classes, cx } = useStyles();

  return (
    <div className={cx(classes.box, className)}>
      <>
        {title && (
          <div className={classes.titleBlock}>
            <Typography variant="h4" component="div">
              {title}
            </Typography>
          </div>
        )}
        <div className={cx(classes.childrenBox, classNameChildren)}>
          {children}
        </div>
      </>
    </div>
  );
};

export default memo(Box);
